import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./components/App/App";
import {BrowserRouter as Router} from "react-router-dom";
import {store} from "./store/store";
import {Provider} from "react-redux";
import { QueryClient, QueryClientProvider } from 'react-query';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 4,
        },
    }

});


ReactDOM.render(
    <Provider store={store}>
<QueryClientProvider client={queryClient}>
        <Router>
            <App/>
        </Router>
</QueryClientProvider>
    </Provider>,
    document.getElementById("root")
);
